import { MoreVertical } from 'lucide-react';
import React from 'react';

interface HelpCenterProps {
  onOpenMenu: () => void;
}

export default function HelpCenter({ onOpenMenu }: HelpCenterProps) {
  return (
    <div className="h-screen md:h-auto bg-[#F5F5F5] flex flex-col">
      <div className="bg-[#FFFFFF] px-4 pt-6 pb-4 flex items-start justify-between border-b border-[#E0E0E0]">
        <h1 className="text-[28px] font-[700] leading-[1.2] text-[#212121] m-0 flex-1 pr-4">
          Help Center
        </h1>
        <button
          onClick={onOpenMenu}
          className="p-2 min-w-[44px] min-h-[44px] flex items-center justify-center bg-transparent border-0 cursor-pointer flex-shrink-0"
          aria-label="Open menu"
        >
          <MoreVertical className="w-6 h-6 text-brand-primary" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto bg-[#FFFFFF] px-4 py-6">
        <div className="max-w-[640px] mx-auto">
          <p> Need help? Email us at</p>
          <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
            <a
              href="mailto:support@ISentryx.com"
              className="text-[#1A73E8] underline hover:no-underline"
            >
              support@ISentryx.com
            </a>
          </h2>
        </div>
      </div>
    </div>
  );
}
